module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-8.a972ef04.png";